import axios from 'axios';
import API_V2_URL from '@/constants/API_V2_URL';

const AuthenticationService = {
  signin(username, password) {
    return axios.post('oauth/token', { username, password, grant_type: 'password' });
  },
  signin_with_signgo(payload, token) {
    const user = payload;
    user.token = token;
    return axios.post(`${API_V2_URL()}/oauth/sign_go/authorize`, user);
  },
  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
  },
};

export default AuthenticationService;



// WEBPACK FOOTER //
// ./src/services/AuthenticationService.js